import clsx from "clsx";
import React, { FC } from "react";

import { Cta, CtaProps } from "../buttons/cta";
import { FooterProps } from "./footer";

export type FooterBottomProps = Pick<FooterProps, "companyInfo" | "bottomLinks">;

export const FooterBottom: FC<FooterBottomProps> = ({ companyInfo, bottomLinks }) => {
  // const getPageFullPath = useGetPageFullPath();

  return (
    <div
      className={clsx(
        "flex flex-col xl:flex-row w-full xl:justify-between pt-3",
        "border-t border-light border-opacity-30 gap-5 sm:gap-4 xl:gap-14"
      )}
    >
      <div className="text-xs md:text-sm xl:text-md text-white font-light text-center xl:text-left">
        {companyInfo}
      </div>
      {bottomLinks && (
        <div className="flex flex-col sm:flex-row justify-center xl:justify-start gap-3">
          {bottomLinks.filter(Boolean).map((ctaProps, i) => {
            return (
              <Cta {...(ctaProps as CtaProps)} key={i}>
                <span className="text-xs md:text-sm xl:text-md text-white font-light">
                  {ctaProps?.label}
                </span>
              </Cta>
            );
          })}
        </div>
      )}
    </div>
  );
};
